import { render, staticRenderFns } from "./StatusCards.vue?vue&type=template&id=f3f84bb6"
import script from "./StatusCards.vue?vue&type=script&lang=js"
export * from "./StatusCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports